import HeroBg from "public/zadara/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Start your Zadara Cloud journey now",
    link: "contact-us",
  },
  desc: "Experience fully managed cloud infrastructure with Zadara Cloud—designed for high performance, security, and cost efficiency. Run mission-critical workloads with on-demand computer, storage, and networking.",
  title: "Enterprise-Grade Cloud with Full Control & Flexibility",
  image: HeroBg,
};
